/** Sozlamalar va Profil (K3), Brief 12. */
export const uzB12Settings = {
  "soz.title": "Sozlamalar",
  "soz.navLabel": "Sozlamalar bo'limlari",
  "soz.section": "Bo'lim",
  "soz.sectionLabel": "Sozlamalar bo'limi",
  "soz.group.agency": "Agentlik",
  "soz.group.distribution": "Taqsimlash",
  "soz.group.ai": "AI",
  "soz.group.finance": "Moliya",
  "soz.group.audit": "Audit",
  "soz.nav.agency": "Agentlik ma'lumotlari",
  "soz.nav.billing": "Tarif va to'lov",
  "soz.nav.funnel": "Voronka",
  "soz.nav.team": "Jamoa va filiallar",
  "soz.nav.distribution": "Taqsimlash qoidalari",
  "soz.nav.channels": "Kanallar",
  "soz.nav.operators": "Turoperatorlar va provayderlar",
  "soz.nav.catalog": "Katalogni moslashtirish",
  "soz.nav.pricing": "Narx va ustamalar",
  "soz.nav.ai": "AI sozlamalari",
  "soz.nav.documents": "Hujjat talablari",
  "soz.nav.templates": "Shablonlar",
  "soz.nav.finance": "Kassalar va to'lov tizimlari",
  "soz.nav.sla": "SLA va eslatmalar",
  "soz.nav.notifications": "Bildirishnomalar",
  "soz.nav.import": "Import",
  "soz.nav.audit": "Audit jurnali",
  "soz.nav.system": "Tizim holati",
  "soz.save": "Saqlash",
  "soz.saved": "Saqlandi",
  "soz.saveFailed": "Saqlab bo'lmadi. Qayta urinib ko'ring.",
  "soz.loadFailed": "Sozlamalarni yuklab bo'lmadi.",
  "soz.upload": "Yuklash",
  "soz.add": "Qo'shish",
  "soz.edit": "Tahrirlash",
  "soz.agency.name": "Nomi",
  "soz.agency.nameHint": "Mijozlarga ko'rinadi",
  "soz.agency.legal": "Yuridik nomi",
  "soz.agency.legalHint": "Shartnoma va hisob-fakturada",
  "soz.agency.inn": "INN",
  "soz.agency.phone": "Telefon",
  "soz.agency.address": "Manzil",
  "soz.agency.rate": "Valyuta kursi",
  "soz.agency.rateHint": "Moliya va narxlarda ishlatiladi",
  "soz.agency.rateSource": "O'zbekiston Markaziy banki (CBU)",
  "soz.agency.rateToday": "Bugun 1 $ = {amount}",
  "soz.agency.rateMissing": "Bugungi kurs hali olinmagan",
  "soz.agency.saved": "Agentlik ma'lumotlari saqlandi",
  "soz.funnel.subtitle": "Bitim bosqichlari va yo'qotish sabablari",
  "soz.team.subtitle": "Xodimlarning joriy holati, ish jadvali va ta'tillari.",
  "soz.team.people": "Xodimlar",
  "soz.team.person": "Xodim",
  "soz.team.add": "Xodim qo'shish",
  "soz.team.onLeave": "Ta'tilda",
  "soz.team.branchCount": "{people} xodim",
  "soz.team.branchClients": "{count} mijoz",
  "soz.team.emptyHint": "Birinchi xodimni taklif qiling.",
  "soz.dist.subtitle": "Yangi murojaat kimga tushishini belgilaydi. Qoidalar yuqoridan pastga tekshiriladi.",
  "soz.dist.rule": "Faqat «Ishda» holatidagi operatorlarga taqsimlansin",
  "soz.dist.ruleHint": "Holatni har bir xodim avatar menyusida o'zi tanlaydi. «Tanaffus» va «Ishda emas» holatidagilar yangi murojaat olmaydi, ta'tildagilarning mijozlari o'rinbosarga o'tadi.",
  "soz.dist.next": "Hozir murojaat oladi: {names}. Keyingisi: {next}.",
  "soz.dist.nobody": "Hozir hech kim «Ishda» emas. Murojaatlar menejerga tushadi.",
  "soz.dist.returning": "Qaytgan mijoz",
  "soz.channels.subtitle": "Mijozlar yozadigan Telegram akkauntlari va Instagram sahifasi",
  "soz.ops.subtitle": "Bronlar, narxlar va operator xabarlari shu ulanishlar orqali keladi.",
  "soz.ops.lastSync": "Oxirgi sinxron",
  "soz.ops.login": "Kirish",
  "soz.ops.count": "{count} ta",
  "soz.pricing.subtitle": "Ustama brutto narxni hisoblaydi. Mijozga yuboriladigan hamma joyda faqat brutto ko'rinadi.",
  "soz.pricing.watch": "Narx kuzatuvi",
  "soz.finance.subtitle": "Moliya bo'limidagi kassalar va onlayn to'lov havolalari",
  "soz.finance.gateways": "To'lov tizimlari",
  "soz.finance.gatewaysHint": "Payme va Click havolalari shu ma'lumotlar bilan yaratiladi",
  "soz.finance.categories": "Xarajat kategoriyalari",
  "soz.finance.categoriesHint": "O'chirilgan kategoriya arxivga o'tadi. Tarixdagi chiqimlar saqlanadi",
  "soz.finance.categoryNew": "Yangi kategoriya",
  "soz.finance.rules": "Valyuta va havolalar",
  "soz.sla.subtitle": "Birinchi javob va eskalatsiya muddatlari",
  "soz.sla.deadlines": "Javob muddatlari",
  "soz.sla.deadlinesHint": "Tinch soatlarda SLA hisoblanmaydi",
  "soz.sla.first": "Birinchi javob",
  "soz.sla.manager": "Menejerga xabar",
  "soz.sla.quiet": "Tinch soatlar",
  "soz.sla.min": "daq",
  "soz.sla.always": "Yo'q, 24 soat",
  "soz.sla.saved": "SLA saqlandi",
  "soz.sla.noBranches": "Filiallar yo'q.",
  "soz.sla.reminders": "Avtomatik eslatmalar",
  "soz.notif.subtitle": "Agentlik darajasidagi qoidalar. Har xodim o'z profilida qo'shimcha sozlaydi",
  "soz.notif.who": "Kimga nima boradi",
  "soz.notif.own": "O'z bildirishnomalaringizni sozlash",
  "soz.system.subtitle": "Kanallar, turoperatorlar, AI va to'lov tizimlari",
  "soz.system.integrations": "Integratsiyalar",
  "soz.system.check": "Hozir tekshirish",
  "soz.system.keys": "Kalitlar",
  "soz.system.aiLimits": "AI chegaralari",
  "soz.system.tours": "Tur qidiruvi va takliflar",
  "soz.tpl.subtitle": "Hujjatlar va suhbatdagi tez javoblar",
  "soz.tpl.replies": "Tez javoblar",
  "soz.tpl.repliesHint": "Suhbatda «/» bilan chaqiriladi",
  "soz.tpl.addReply": "Javob qo'shish",
  "soz.tpl.editReply": "Javobni tahrirlash",
  "soz.tpl.command": "Buyruq",
  "soz.tpl.text": "Matn",
  "soz.tpl.noReplies": "Tez javoblar hali yo'q.",
  "soz.denied": "Sozlamalar agentlik egasi va menejeriga ochiq.",
  "settings.cap.view_sales_reports": "Sotuv hisobotlarini ko'rish",
  "settings.cap.view_custdev": "CustDev hisobotini ko'rish",
  "settings.cap.see_passport": "Pasportni to'liq ko'rish",
  "settings.cap.manage_destinations": "Yo'nalishlarni sozlash",
  "settings.cap.use_inbox": "Suhbatlarda ishlash",
  "soz.ops.cap.search": "Qidiruv",
  "soz.ops.cap.claims": "Bronlar",
  "soz.ops.cap.hotels": "Mehmonxonalar",
  "soz.ops.cap.rates": "Kurslar",
  "soz.ops.cap.reference": "Ma'lumotnoma",
  "soz.ops.cap.points": "Joylar",
  "soz.agency.language": "Til",
  "soz.team.duty": "Navbatchilik",
  "soz.team.access": "Suhbatlarga kirish",
  "soz.ops.capabilities": "Imkoniyat",
  "soz.finance.notConnected": "Ulanmagan",
  "soz.finance.gatewayWait": "Merchant ma'lumotlarini Kapitan jamoasi ulaydi. Ulangach, shu yerda holati ko'rinadi.",
  "settings.cash.branchCol": "Filial",
  "soz.sla.hours": "Ish vaqti",
  "soz.sla.opens": "Ochilish",
  "soz.sla.closes": "Yopilish",
  "prof.navHint": "Profil sozlamalari",
  "prof.navLabel": "Profil bo'limlari",
  "prof.photo": "Rasm",
  "prof.photoHint": "JPG yoki PNG, 400×400 dan katta",
  "prof.nameAndContact": "Ism va aloqa",
  "prof.firstName": "Ism",
  "prof.lastName": "Familiya",
  "prof.workplace": "Ish joyi",
  "prof.workplaceHint": "faqat egasi o'zgartiradi",
  "prof.schedule.subtitle": "Holat murojaatlar taqsimlanishiga ta'sir qiladi.",
  "prof.schedule.now": "Hozirgi holat",
  "prof.schedule.nowHint": "«Ishda» holatida yangi murojaatlar sizga yuboriladi",
  "prof.schedule.days": "Ish kunlari",
  "prof.schedule.hours": "Ish vaqti",
  "prof.schedule.from": "dan",
  "prof.schedule.to": "gacha",
  "prof.schedule.leave": "Ta'til yoki kasallik",
  "prof.schedule.leaveHint": "menejer tasdiqlagandan keyin kuchga kiradi",
  "prof.look.darkRail": "Qorong'i yon panel",
  "prof.look.darkRailHint": "Faqat shu qurilmada",
  "prof.look.langHint": "Turoperator xabarlari asl tilida qoladi",
  "prof.look.moneyTitle": "Summalarni ko'rsatish",
  "prof.look.moneyHint": "Ro'yxat va kartochkalarda",
  "prof.notif.subtitle": "Qaysi hodisa qaysi kanalga kelishini tanlang.",
  "prof.notif.event": "Hodisa",
  "prof.notif.quiet": "Jim rejim",
  "prof.notif.quietHint": "Faqat tizim ichida, ovoz va push yo'q",
  "prof.signature.hint": "AI tayyorlagan matnlarga ham qo'shiladi",
  "prof.signature.text": "Imzo matni",
  "prof.security.password": "Parol",
  "prof.security.passwordChange": "Parolni o'zgartirish",
  "prof.security.twoFactorHint": "Kirishda Telegram orqali kod keladi",
  "prof.security.devices": "Faol qurilmalar",
  "prof.security.telegram": "Telegram bot",
  "prof.deny.title": "Ruxsat yo'q",
  "soz.billing.title": "Tarif va to'lov",
  "soz.billing.subtitle": "Kapitan obunasi, limitlar va hisob-fakturalar",
  "soz.billing.current": "Joriy tarif",
  "soz.billing.nextPayment": "Keyingi to'lov {date}",
  "soz.billing.change": "Tarifni o'zgartirish",
  "soz.billing.buy": "Kredit sotib olish",
  "soz.billing.tariff": "Tarif",
  "soz.billing.noTariff": "Tarif belgilanmagan",
  "soz.billing.perMonth": "{name} · oyiga {price}",
  "soz.billing.members": "Foydalanuvchilar",
  "soz.billing.branches": "Filiallar",
  "soz.billing.credits": "AI kreditlar",
  "soz.billing.creditsSplit": "paket {package} · sotib olingan {purchased}",
  "soz.billing.expiring": "{count} ta 7 kun ichida tugaydi",
  "soz.billing.lasts": "~{days} kunga yetadi",
  "soz.billing.balance": "Balans",
  "soz.billing.method": "To'lov usuli",
  "soz.billing.methodBank": "Bank o'tkazmasi",
  "soz.billing.ledger": "Balans harakati",
  "soz.billing.ledgerHint": "Har bir to'ldirish va yechim shu yerda qoladi",
  "soz.billing.ledgerEmpty": "Hali harakat yo'q.",
  "soz.billing.date": "Sana",
  "soz.billing.description": "Tavsif",
  "soz.billing.amount": "Summa",
  "soz.billing.status": "Holat",
  "soz.billing.requests": "Kredit so'rovlari",
  "soz.billing.requestsHint": "Platforma to'lovni tasdiqlagach, kreditlar beriladi",
  "soz.billing.requestsFailed": "So'rovlarni yuklab bo'lmadi.",
  "soz.billing.creditCount": "Kredit",
  "soz.billing.usage": "Sarf tarixi",
  "soz.billing.at": "Vaqt",
  "soz.billing.note": "Izoh",
  "soz.billing.ownerOnly": "Bu bo'limni ko'rish huquqi yo'q.",
  "soz.billing.sent": "So'rov yuborildi. Platforma to'lovni tasdiqlagach, kreditlar beriladi.",
  "soz.billing.sendFailed": "So'rovni yuborib bo'lmadi.",
  "soz.billing.creditsField": "Kreditlar soni (1 — {max})",
  "soz.billing.priceNote": "Narx tarifdan olinadi. To'lov bank o'tkazmasi orqali amalga oshiriladi; so'rov tasdiqlangunga qadar hech narsa yechilmaydi.",
  "soz.billing.noteField": "Izoh (ixtiyoriy)",
  "soz.billing.send": "So'rov yuborish",
  "soz.import.title": "Import",
  "soz.import.subtitle": "Excel yoki Google Sheets dan mijozlarni ko'chirish",
  "soz.import.new": "Yangi import",
  "soz.import.newHint": "XLSX yoki CSV · ustunlarni keyingi qadamda moslaysiz",
  "soz.import.choose": "Fayl tanlash",
  "soz.import.sample": "Namuna fayl",
  "soz.import.fileLabel": "Import fayli",
  "soz.import.note": "Telefon raqami bir xil bo'lgan mijozlar qayta qo'shilmaydi. Import 24 soat ichida bekor qilinadi.",
  "soz.import.history": "Import tarixi",
  "soz.import.historyEmpty": "Hali import qilinmagan.",
  "soz.import.file": "Fayl",
  "soz.import.rows": "Qatorlar",
  "soz.import.who": "Kim",
  "soz.import.rowsDone": "{count} ta",
  "soz.import.rowsErrors": "{count} ta · {failed} xato",
  "soz.import.uploadFailed": "Faylni yuklab bo'lmadi.",
  "soz.import.batchFailed": "Partiyani yuklab bo'lmadi.",
  "soz.import.rowCount": "{count} qator",
  "soz.import.other": "Boshqa fayl",
  "soz.import.step1": "1. Ustunlarni moslang",
  "soz.import.required": "{label} (majburiy)",
  "soz.import.noColumn": "— ustun yo'q",
  "soz.import.missing": "Majburiy ustunlar tanlanmagan: {fields}",
  "soz.import.allChosen": "Majburiy ustunlar tanlangan.",
  "soz.import.mapSaved": "Moslash saqlandi.",
  "soz.import.mapFailed": "Moslashni saqlab bo'lmadi.",
  "soz.import.committed": "Mijozlar import qilindi.",
  "soz.import.commitFailed": "Importni yakunlab bo'lmadi.",
  "soz.import.mapFirst": "Avval majburiy ustunlarni moslang: ko'rinish shu yerda chiqadi.",
  "soz.import.step2": "2. Oldindan ko'rish",
  "soz.import.willImport": "Import qilinadi: {count}",
  "soz.import.willSkip": "o'tkaziladi: {count}",
  "soz.import.noRows": "Qatorlar yo'q.",
  "soz.import.row": "Qator",
  "soz.import.name": "Ism",
  "soz.import.phone": "Telefon",
  "soz.import.duplicate": "Bor mijoz, o'tkaziladi",
  "soz.import.willBe": "Import qilinadi",
  "soz.import.commit": "Import qilish",
  "soz.import.reverted": "Import bekor qilindi.",
  "soz.import.revertFailed": "Bekor qilib bo'lmadi.",
  "soz.import.step3": "3. Hisobot",
  "soz.import.statImported": "Import qilindi",
  "soz.import.statFailed": "Xato bilan o'tkazildi",
  "soz.import.statTotal": "Jami qator",
  "soz.import.errors": "Xatolarni yuklab olish",
  "soz.import.errorsFailed": "Xatolar faylini yuklab bo'lmadi.",
  "soz.import.revert": "Importni bekor qilish",
  "soz.import.revertedNote": "Bu import bekor qilingan. Siz bilan ishlagan mijozlar saqlab qolingan.",
  "soz.audit.subtitle": "Kim, qachon, nima qildi. Yozuvlarni o'chirib bo'lmaydi",
  "soz.audit.recent": "Oxirgi harakatlar",
  "soz.audit.csv": "CSV eksport",
  "soz.audit.csvFailed": "Faylni yuklab bo'lmadi.",
  "soz.audit.filters": "Filtrlar",
  "soz.audit.chip.passport": "Pasport ko'rish",
  "soz.audit.chip.storno": "To'lov storno",
  "soz.audit.chip.ai": "AI sozlamasi",
  "soz.audit.chip.login": "Kirish",
  "soz.audit.staff": "Xodim",
  "soz.audit.action": "Harakat",
  "soz.audit.severityInfo": "Ma'lumot",
  "soz.audit.severityWarning": "Ogohlantirish",
  "soz.audit.severityCritical": "Muhim",
  "soz.audit.kind.user": "Foydalanuvchi",
  "soz.audit.kind.ai": "AI agent",
  "soz.audit.kind.automation": "Avtomatizatsiya",
  "soz.audit.kind.system": "Tizim",
  "soz.audit.kind.platform_admin": "Platforma administratori",
  "soz.audit.kind.client": "Mijoz",
  "soz.audit.kind.gateway": "To'lov tizimi",
  "soz.audit.label.auth.login": "Tizimga kirdi",
  "soz.audit.label.auth.login_failed": "Kirish rad etildi",
  "soz.audit.label.traveler.passport_viewed": "Pasport ko'rildi",
  "soz.audit.label.payment.storno": "To'lov storno",
  "soz.audit.label.payment.approved": "To'lov tasdiqlandi",
  "soz.audit.label.settings.changed": "Sozlama o'zgartirildi",
  "soz.audit.label.export.created": "Eksport yuklab olindi",
  "soz.funnel.stages": "Bosqichlar",
  "soz.funnel.stagesHint": "Tizim bosqichlari hisobot va avtomatlashtirishga bog'langan",
  "soz.funnel.system": "{name} · tizim",
  "soz.funnel.earlier": "{name}ni oldinga surish",
  "soz.funnel.later": "{name}ni orqaga surish",
  "soz.funnel.reasons": "Yo'qotish sabablari",
  "soz.funnel.reasonsHint": "Bitimni yo'qotilganga o'tkazishda tanlanadi",
  "soz.funnel.reasonsEmpty": "Sabablar hali qo'shilmagan.",
  "soz.funnel.cold": "Sovigan bitim",
  "soz.finance.cashHint": "Kassani o'chirsangiz, arxivga o'tadi. Tarixdagi to'lovlar saqlanadi",
  "soz.finance.cash": "Kassa",
  "soz.finance.kind": "Turi",
  "soz.finance.allBranches": "Hammasi",
  "soz.channels.telegramHint": "Har akkaunt filialga biriktiriladi",
  "soz.channels.connect": "Telegram ulash",
  "soz.channels.account": "Akkaunt",
  "soz.channels.branch": "Filial",
  "soz.channels.state": "Holat",
  "soz.channels.note": "Izoh",
  "soz.channels.lastMessage": "oxirgi xabar {when}",
  "soz.channels.noMessage": "hali xabar yo'q",
  "soz.channels.actions": "{name}: amallar",
  "soz.channels.reconnect": "Qayta ulash",
  "soz.channels.settings": "Sozlamalar",
  "soz.channels.disconnect": "Uzish",
  "soz.channels.settingsTitle": "{name}: sozlamalar",
  "soz.channels.loadFailed": "Akkauntlar ro'yxatini yuklab bo'lmadi.",
  "soz.channels.none": "Telegram akkaunti hali ulanmagan.",
  "soz.channels.historyFailed": "Tarix import qilinmadi",
  "soz.channels.instagramHint": "Direct va kommentlar",
  "igSet.network": "Server bilan aloqa yo'q. Qaytadan urinib ko'ring.",
  "igSet.callbackFailed": "Instagram ulanmadi. Qaytadan urinib ko'ring.",
  "igSet.ownerOnly": "Instagram ulanishini faqat egasi boshqaradi.",
  "igSet.connected": "Instagram ulandi.",
  "igSet.working": "Ulanish ishlayapti.",
  "igSet.disconnected": "Instagram uzildi.",
  "igSet.loadFailed": "Instagram holatini yuklab bo'lmadi.",
  "igSet.retry": "Qayta urinish",
  "igSet.connect": "Ulash",
  "igSet.confirmTitle": "Instagram uzilsinmi?",
  "igSet.cancel": "Bekor qilish",
  "igSet.disconnect": "Uzish",
  "igSet.confirmBody": "{account} Direct va kommentlari Kapitan'ga kelmay qoladi. AI bu kanalda to'xtaydi.",
  "igSet.thisAccount": "Bu hisob",
  "igSet.connectedAt": "Ulangan sana",
  "igSet.tokenExpires": "Token muddati",
  "igSet.lastSuccess": "Oxirgi muvaffaqiyatli tekshiruv",
  "igSet.webhook": "Webhook",
  "igSet.webhookOn": "Faol",
  "igSet.webhookOff": "Faol emas",
  "igSet.test": "Ulanishni tekshirish",
  "igSet.phase.notConfigured": "Sozlanmagan",
  "igSet.phase.notConnected": "Ulanmagan",
  "igSet.phase.stateConnected": "Ulangan",
  "igSet.phase.expiring": "Token tez orada tugaydi",
  "igSet.phase.fallback": "Sozlanmagan — Platforma → Integratsiyalar → Meta",
  "igSet.phase.error": "Xato",
  "soz.channels.status": "Holat",
  "soz.channels.excluded": "Chiqarib tashlangan suhbatlar",
  "soz.channels.telegram": "Telegram akkauntlari",
  "soz.finance.addCash": "Kassa qo'shish",
  "soz.funnel.addStage": "Bosqich qo'shish",
  "prof.security.more": "Yana {count} ta qurilma",
  "soz.error.title": "Sozlamalar yuklanmadi",
  "soz.error.message": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "soz.loading": "Ma'lumot olinmoqda…",
  "soz.error.code": "Xato {status} · {when}",
  "soz.channels.rules": "Kanal qoidalari",
  "soz.system.lastCheck": "Oxirgi tekshiruv: {time}",
  "soz.system.subtitleLive": "Kanallar, turoperatorlar, AI va to'lov tizimlari · har 5 daqiqada yangilanadi",
  "soz.katalog.kpi.matchedHint": "Avtomatik va tasdiqlangan",
  "soz.katalog.kpi.reviewHint": "Ishonchlilik 90% dan past",
  "soz.katalog.kpi.unmatchedNote": "Bu turlar qidiruvda chiqmaydi",
  "soz.katalog.more": "{name}: boshqa amallar",
} as const;
